(function ($) {
  'use strict';

  $(document).ready(function () {
    // ── Category filter ────────────────────────────────────────────────────
    const $serviceSelect = $('#select_service');
    const $allOptions = $serviceSelect.find('option').clone();

    function filterServicesByCategory(selectedCat) {
      $serviceSelect.empty();

      let firstVisible = null;

      $allOptions.each(function () {
        const cats = $(this).attr('data-categories') || '';
        const catList = cats.split(',').map(function (id) {
          return id.trim();
        });
        const show = !selectedCat || catList.indexOf(selectedCat) !== -1;

        if (show) {
          $serviceSelect.append($(this).clone());
          if (firstVisible === null) {
            firstVisible = $(this).val();
          }
        }
      });

      $serviceSelect.val(firstVisible || '');
    }

    $('#service_category_filter').on('change', function () {
      filterServicesByCategory($(this).val());
    });

    $('#addServiceModal').on('show.bs.modal', function () {
      const $catFilter = $('#service_category_filter');
      $catFilter.val($catFilter.find('option:first').val());
      filterServicesByCategory($catFilter.val());
    });
    // ──────────────────────────────────────────────────────────────────────

    // ── Add service ────────────────────────────────────────────────────────
    $('#add-service-form').on('submit', function (e) {
      e.preventDefault();
      $('#loading').addClass('d-flex');

      const formData = new FormData(this);
      formData.append('action', 'service_provider_add_service');
      // nonce is already included via the wp_nonce_field hidden input (#wp_nonce)

      $.ajax({
        url: window.ajax_callback_data.ajax_url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function (response) {
          if (response.success) {
            location.reload();
          } else {
            $('#loading').removeClass('d-flex');
            console.warn(response.message);
          }
        },
        error: function () {
          $('#loading').removeClass('d-flex');
        },
      });
    });

    // ── Toggle service status ──────────────────────────────────────────────
    $('.service-listing-actions .toggle-service-status').on(
      'click',
      function () {
        $('#loading').addClass('d-flex');

        const serviceIndex = $(this).closest('tr').data('index');
        const status = $(this).attr('status');

        $.ajax({
          url: window.ajax_callback_data.ajax_url,
          type: 'POST',
          data: {
            action: 'service_provider_toggle_service_status',
            nonce: window.ajax_callback_data.ajax_nonce,
            serviceIndex,
            status,
          },
          success: function (response) {
            if (response.success) {
              location.reload();
            } else {
              $('#loading').removeClass('d-flex');
              console.warn(response.message);
            }
          },
          error: function () {
            $('#loading').removeClass('d-flex');
          },
        });
      },
    );

    // ── Delete service ─────────────────────────────────────────────────────
    $('.service-listing-actions .delete-service').on('click', function () {
      $('#loading').addClass('d-flex');

      const serviceIndex = $(this).closest('tr').data('index');

      $.ajax({
        url: window.ajax_callback_data.ajax_url,
        type: 'POST',
        data: {
          action: 'service_provider_delete_service',
          nonce: window.ajax_callback_data.ajax_nonce,
          serviceIndex,
        },
        success: function (response) {
          if (response.success) {
            location.reload();
          } else {
            $('#loading').removeClass('d-flex');
            console.warn(response.message);
          }
        },
        error: function () {
          $('#loading').removeClass('d-flex');
        },
      });
    });
  });
})(jQuery);
